module.exports = __webpack_public_path__ + "static/media/boat-img-4.1f07be21.jpg";